var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDsBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.914,
    height: 27.926,
    viewBox: "0 0 27.914 27.926",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "data-scroll-svgrepo-com",
    transform: "translate(-147.091 -43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M.739,7.191H20.682a.648.648,0,0,0,.648-.648V.648A.648.648,0,0,0,20.682,0H.739A.648.648,0,0,0,.091.648V6.542A.648.648,0,0,0,.739,7.191ZM2.2,1.726h8.512v3.4H2.2ZM21.331,12.506V9.343a.648.648,0,0,0-.648-.648H.739a.648.648,0,0,0-.648.648v5.894a.648.648,0,0,0,.648.649h12.1V14.818a2.315,2.315,0,0,1,2.313-2.313Zm-10.62,1.232H2.2v-3.4h8.512ZM.091,17.954v5.894a.648.648,0,0,0,.648.648h12.1V17.306H.739A.648.648,0,0,0,.091,17.954ZM2.2,19.2h8.512v3.4H2.2ZM26.9,13.877H15.718a.942.942,0,0,0-.942.942V24.855h0a.312.312,0,0,0,.622,0h0V14.819a.314.314,0,0,1,.314-.314h9.63a.314.314,0,0,1,.314.314V26.984a.315.315,0,0,1-.314.314H24.092c-.116-.049-.579-.269-.579-.61,0-.392.6-.634.609-.637a.314.314,0,0,0-.11-.608h-8.9a1.237,1.237,0,1,0,0,2.475h8.563s0,0,0,.008h1.676a.943.943,0,0,0,.941-.942V14.935c0-.442.542-.431.6-.431h0a.483.483,0,0,1,0,.965.314.314,0,1,0,0,.628,1.11,1.11,0,0,0,.01-2.22ZM23.079,27.29H15.11a.61.61,0,1,1,0-1.219h7.978a1.034,1.034,0,0,0-.009,1.219Z",
    transform: "translate(147 43)",
    fill: "#007cab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_484",
    "data-name": "Rectangle 484",
    width: 11,
    height: 11,
    transform: "translate(162.336 57.139)",
    fill: "#007cab"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsBlue);
export default __webpack_public_path__ + "static/media/DS_Blue.3678072eb8bba7b4df613e1e06b88770.svg";
export { ForwardRef as ReactComponent };